/**
 * HamburgerIcon - 開閉状態に応じてハンバーガー(≡)と閉じる(×)を滑らかに切り替えるアイコン
 *
 * open=true で上下の線が中央に寄って回転し ×、中央の線がフェードアウトする。
 */

import { cn } from '@/lib/utils'

type HamburgerIconProps = {
  /** 開いているか（true で × 形状になる） */
  open: boolean
  className?: string
}

export const HamburgerIcon = ({ open, className }: HamburgerIconProps) => {
  return (
    <span className={cn('relative block size-5', className)} aria-hidden>
      <span
        className={`absolute left-0 block h-0.5 w-5 rounded-full bg-current transition-all duration-300 ${
          open ? 'top-1/2 -translate-y-1/2 rotate-45' : 'top-1'
        }`}
      />
      <span
        className={`absolute top-1/2 left-0 block h-0.5 w-5 -translate-y-1/2 rounded-full bg-current transition-all duration-300 ${
          open ? 'opacity-0' : 'opacity-100'
        }`}
      />
      <span
        className={`absolute left-0 block h-0.5 w-5 rounded-full bg-current transition-all duration-300 ${
          open ? 'top-1/2 -translate-y-1/2 -rotate-45' : 'bottom-1'
        }`}
      />
    </span>
  )
}
